import { render, staticRenderFns } from "./account_managed.vue?vue&type=template&id=51773a81&"
import script from "./account_managed.vue?vue&type=script&lang=js&"
export * from "./account_managed.vue?vue&type=script&lang=js&"
import style0 from "./account_managed.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports